'use strict';

import * as C from '../../../../assets/js/_constants';

export default class CartDiscounts {
  /**
   * @type {AppConfig}
   */
  #config;

  /**
   * @type {string}
   */
  #page;

  /**
   * @type {{}}
   */
  #global;

  /**
   * @type {{}}
   */
  #cartApi;

  /**
   * @param {string} appName
   * @param {AppConfig} config
   * @param {string} page
   */
  constructor(appName, config, page) {
    this.#config = config;
    this.#page = page;
    this.#global = window.Spurit.global;
    this.#cartApi = this.#global.cartPool.getAdapter(appName);
  }

  /**
   *
   */
  run() {
    this.#setupSelectors();
    this.#cartApi.onChange(() => this.#processCart());
    this.#processCart();
  }

  /**
   *
   */
  #processCart() {
    let lineItems = this.#cartApi.getItems();
    lineItems.forEach(lineItem => {
      let variantId = lineItem.id;
      let variant = this.#config.snippet().getVariantDetails(variantId);
      let settings = this.#config.getSettingsByVariantId(variantId);
      if (!variant || !settings) {
        return;
      }

      const preOrderLabel = settings.config.preOrderLabel;
      if (!lineItem.properties || !lineItem.properties[preOrderLabel]) {
        return;
      }

      let discount = settings.discount;
      if (discount.value) {
        const preOrderAmount = parseInt(lineItem.properties[preOrderLabel]);
        const discountValue = preOrderAmount ? (preOrderAmount / lineItem.quantity) * discount.value: discount.value;
        if (discount.type === C.DISCOUNT_TYPE_PERCENTAGE) {
          lineItem.addPercentInvisibleDiscount(discountValue);
        } else if (discount.type === C.DISCOUNT_TYPE_FIXED) {
          lineItem.addFixedInvisibleDiscount(discountValue);
        }
      } else {
        lineItem.removeDiscount();
      }
    });
  }

  /**
   *
   */
  #setupSelectors() {
    let selectors = this.#config.settings().config.selectors_discount;
    let selectorTypes = this.#global.constants.SELECTOR;

    if (selectors.hasShopAjaxCart) {
      if (selectors.ajax_cart.price_individual) {
        this.#global.selectors.add(selectors.ajax_cart.price_individual, selectorTypes.CART_INDIVIDUAL);
      }
      if (selectors.ajax_cart.price_total) {
        this.#global.selectors.add(selectors.ajax_cart.price_total, selectorTypes.CART_TOTAL);
      }
      if (selectors.ajax_cart.price_subtotal) {
        this.#global.selectors.add(selectors.ajax_cart.price_subtotal, selectorTypes.CART_SUBTOTAL);
      }
      if (selectors.ajax_cart.button_checkout) {
        this.#global.checkout.addButton(selectors.ajax_cart.button_checkout);
      }
    }

    if (this.#page === 'cart') {
      if (selectors.cart.price_individual) {
        this.#global.selectors.add(selectors.cart.price_individual, selectorTypes.CART_INDIVIDUAL);
      }
      if (selectors.cart.price_total) {
        this.#global.selectors.add(selectors.cart.price_total, selectorTypes.CART_TOTAL);
      }
      if (selectors.cart.price_subtotal) {
        this.#global.selectors.add(selectors.cart.price_subtotal, selectorTypes.CART_SUBTOTAL);
      }
    }
  }
}